import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { periodsApi } from '../periods';

export const periodsKeys = ['admin', 'timetable', 'periods'] as const;

export function usePeriodsQuery() {
  return useQuery({ queryKey: periodsKeys, queryFn: () => periodsApi.list() });
}

export function useCreatePeriodMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: Parameters<typeof periodsApi.create>[0]) => periodsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: periodsKeys }),
  });
}

export function useUpdatePeriodMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof periodsApi.update>[1] }) =>
      periodsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: periodsKeys }),
  });
}

export function useDeletePeriodMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => periodsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: periodsKeys }),
  });
}
